// extracted by mini-css-extract-plugin
export default {"coachItem":"coach_coachItem__zRvpy","coaching":"coach_coaching__9E-wi","coachImg":"coach_coachImg__vfZlQ"};